<template>
    <div class="col-12">
        <div class="row">
            <div class="col-12">
               <h4 class="headingLevel mb-4">
                <div class="custom-control custom-checkbox b-custom-control-lg mb-1">
                    <input
                        type="checkbox"
                        :id="'show_date_perpetual_' + product.id"
                        v-model="leaseOptions.showPerpetualUpgrade"
                        @change="updateLeaseOptions($event)"
                        class="custom-control-input"
                    >
                    <label :for="'show_date_perpetual_' + product.id" class="custom-control-label d-flex flex-wrap" >
                        {{ getTranslation('licence-configurator', 'upgrade_to_perpetual') }}
                    </label>
                </div>
                </h4>
            </div>
            <div
                :class="leaseOptions.showPerpetualUpgrade === true ? 'mb-4' : 'd-none'"
            >
                <div v-for="program in filteredPrograms" :key="program.id" class="col-12  ">
                    <div class="pl-5">
                        <div class="custom-control custom-checkbox b-custom-control-lg mb-4 " >
                            <input
                                type="checkbox"
                                :id="'upgradePerpetual_' + program.id"
                                value = "1"
                                @change="upgradePerpetual($event, program)"
                                class="custom-control-input"
                                :checked="program.perpetual_upgrade"
                            >
                            <label :for="'upgradePerpetual_' + program.id" class="custom-control-label" style="font-size: 16px;">
                                <span style="font-weight: 400;">{{ program.name }}</span>
                                <b style="font-weight: 700;">{{ priceFormat(getProgramPrice(program.id, '', 'cloud_time_quantity', program.product, program.cloud_time_quantity * 3)) }}</b>
                            </label>

                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>

export default {
        methods: {
            updateLeaseOptions() {
                let self = this;

                _.forEach(this.filteredPrograms, function(p) {
                    let payload = {
                        id: p.id,
                        upgrade: self.leaseOptions.showPerpetualUpgrade,
                        column: 'perpetual_upgrade'
                    }
                    self.$store.commit('upgradeCartProgram', payload);
                });

                let payload = {
                    id: this.product.id,
                    data: this.leaseOptions,
                }

                this.$store.commit('updateLeaseOptions', payload);
            },
            upgradePerpetual(event, program) {
                let payload = {
                    id: program.id,
                    upgrade: event.target.checked,
                    column: 'perpetual_upgrade'
                }
                this.$store.commit('upgradeCartProgram', payload);
            }
        },
        beforeMount() {
            this.leaseOptions = this.$store.state.cart.leaseOptions[this.product.id];
        },
        mounted() {

        },
        computed: {
            filteredPrograms() {
                return this.$store.state.cart.programs.filter(program => program.product == this.product.id);
            }
        },
        data() {
            return {
                products: window.jsonProducts,
                leaseOptions: {},
            };
        },
        props: {
            product: Object,
        }
    }
</script>
